@if (!loading) {
  @if (icon) {
    <mat-icon [svgIcon]="icon"></mat-icon>
  }
} @if (badge && !loading) {
<span class="badge" [ngClass]="badgeColor"></span>
} @if (count && !loading) {
<span class="count" [ngClass]="countColor">{{ count }}</span>
} @if (loading) {
<mat-spinner [diameter]="28" [strokeWidth]="3"></mat-spinner>
}
